// Configuración del API de WhatsApp para CentralGym
// Este archivo define las URLs y configuraciones necesarias para conectar
// con el servidor Node.js de WhatsApp Web

const WhatsAppApiConfig = {
  // URL base del servidor de WhatsApp API
  // En desarrollo: http://localhost:3001
  // En producción: cambiar por la URL del servidor
  apiBaseUrl: process.env.VUE_APP_WHATSAPP_API_URL || 'http://localhost:3001',

  // Configuración de Socket.IO
  socketConfig: {
    transports: ['websocket', 'polling'],
    timeout: 20000,
    forceNew: true,
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000
  },

  // Timeouts para diferentes operaciones
  timeouts: {
    initialize: 30000,     // 30 segundos para inicializar
    socketConnect: 10000,  // 10 segundos para conectar Socket.IO
    apiRequest: 30000,     // 30 segundos para requests API
    qrWait: 60000         // 60 segundos para esperar QR
  },

  // Configuración de debug
  debug: {
    enabled: process.env.NODE_ENV !== 'production',
    logSocketEvents: true,
    logApiRequests: true,
    logQrEvents: true
  },

  // Endpoints del API
  endpoints: {
    initialize: '/api/whatsapp/initialize',
    disconnect: '/api/whatsapp/disconnect',
    sendMessage: '/api/whatsapp/send-message',
    sendTemplate: '/api/whatsapp/send-template',
    sendBulk: '/api/whatsapp/send-bulk',
    checkNumber: '/api/whatsapp/check-number',
    status: '/api/whatsapp/status'
  },

  // Configuración de reintentos
  retry: {
    maxAttempts: 3,
    delay: 2000,
    backoff: 1.5
  }
};

// Función para obtener la configuración completa
export const getWhatsAppApiConfig = () => {
  return {
    ...WhatsAppApiConfig,
    fullEndpoints: Object.keys(WhatsAppApiConfig.endpoints).reduce((acc, key) => {
      acc[key] = WhatsAppApiConfig.apiBaseUrl + WhatsAppApiConfig.endpoints[key];
      return acc;
    }, {})
  };
};

// Función para validar la configuración
export const validateWhatsAppApiConfig = () => {
  const config = getWhatsAppApiConfig();
  
  // Verificar que la URL base esté definida
  if (!config.apiBaseUrl) {
    throw new Error('URL del API de WhatsApp no configurada');
  }

  // Verificar que la URL sea válida
  try {
    new URL(config.apiBaseUrl);
  } catch (error) {
    throw new Error('URL del API de WhatsApp no es válida: ' + config.apiBaseUrl);
  }

  return true;
};

// Función de debug para mostrar la configuración actual
export const debugWhatsAppApiConfig = () => {
  const config = getWhatsAppApiConfig();
  
  console.log('🔧 Configuración WhatsApp API:', {
    apiBaseUrl: config.apiBaseUrl,
    environment: process.env.NODE_ENV,
    debug: config.debug.enabled,
    endpoints: config.fullEndpoints
  });
  
  return config;
};

export default WhatsAppApiConfig; 